// extracted by mini-css-extract-plugin
export default {"root":"growls-module___root___f38dc450"};